export const BUSINESS_TYPES = {
	REAL: 'real',
	LEGAL: 'legal',
};
